import { ContactsIcon } from "@minket/brand/icons/contacts";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { GhostSections } from "@/components/page/ghost";
import { DetailPage } from "@/components/page/item";
import { Page } from "@/components/page/page";
import { LoadingState } from "@/components/page/states";
import { endpoints } from "@/lib/endpoints";
import { apiQuery } from "@/lib/query";
import { useWorkspace } from "@/lib/workspace";

// The page loads on its own once the contact has, so the shell names one chunk for it.
const ContactDocument = lazy(() =>
  import("@/components/audience/contact-page").then((m) => ({ default: m.ContactDocument })),
);

export const Route = createFileRoute("/contacts/$id")({
  component: ContactPage,
});

const sections = [
  { title: "Subscriptions", description: "" },
  { title: "Consent ledger", description: "", wide: true },
  {
    title: "Contact",
    description: "",
    fields: ["Email", "Name", "Status", "Added"],
  },
  { title: "History", description: "" },
] as const;

function ContactPage() {
  const { id } = Route.useParams();
  const { project } = useWorkspace();
  const contact = useQuery({
    ...apiQuery(endpoints.contact, { projectId: project?.id ?? "", contactId: id }),
    enabled: project !== null,
  });
  if (project && contact.isSuccess) {
    return (
      <Suspense
        fallback={
          <Page title="Contact" back={{ to: "/contacts", label: "Contacts" }}>
            <LoadingState label="Loading the contact">
              <GhostSections sections={sections} />
            </LoadingState>
          </Page>
        }
      >
        <ContactDocument projectId={project.id} contact={contact.data} />
      </Suspense>
    );
  }
  return (
    <DetailPage
      kind="Contact"
      icon={ContactsIcon}
      id={id}
      back={{ to: "/contacts", label: "Contacts" }}
      noun="this contact"
      will="This page will hold the contact's subscriptions, its consent ledger, its fields and its history."
      sections={sections}
      query={(projectId) => apiQuery(endpoints.contact, { projectId, contactId: id })}
    />
  );
}
